import { WebPlugin } from '@capacitor/core';
export class SpeechRecognitionWeb extends WebPlugin {
    available() {
        throw this.unimplemented('Speech recognition is not available on the web.');
    }
    start(_options) {
        throw this.unimplemented('Speech recognition is not available on the web.');
    }
    stop() {
        throw this.unimplemented('Speech recognition is not available on the web.');
    }
    getSupportedLanguages() {
        throw this.unimplemented('Speech recognition is not available on the web.');
    }
    isListening() {
        throw this.unimplemented('Speech recognition is not available on the web.');
    }
    checkPermissions() {
        throw this.unimplemented('Speech recognition permissions are not handled on the web.');
    }
    requestPermissions() {
        throw this.unimplemented('Speech recognition permissions are not handled on the web.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map